import React from "react";
import { Link } from "@quintype/components";
import { shape, string, array } from "prop-types";
import useUrl from "../../../hook/useUrl";
import "./author-name.m.css";

const Author = ({ authors }) => {
  const [_, currentUrlSlug] = useUrl();
      return (
        (currentUrlSlug === "vaasalehti" || currentUrlSlug === "epari") ?
        <div styleName="author-name">{authors.name}</div>
        :
        <Link href={"/author/" + authors.slug} >
        {authors.name}
        </Link>
        )

};

Author.propTypes = {
  authors: shape({
    slug: string,
    name: string
  })
};

const AuthorSlug = ({ authors = [] }) => {
  return (
    <div styleName="authors">
      <ul>
        {authors.map((authors, index) => {
          return (
            <li key={index}>
              <Author authors={authors} />
            </li>
          );
        })}
      </ul>
    </div>

  );
};

AuthorSlug.propTypes = {
  authors: array
};

export default AuthorSlug;
